export const toTitleCase = str => {
  if (Array.isArray(str)) return str.map(s => toTitleCase(s));
  if (!str || typeof str !== 'string') return str ?? '';
  return str
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
};

export const phoneFormatter = phoneNumber => {
  return `${phoneNumber.slice(-3)} ${phoneNumber.slice(0, -3)}`;
};

export const mpinFormatter = mpin => {
  return mpin.padStart(9, '0');
};
